import {cast, Instance, types} from "mobx-state-tree";

import {getGqlModelBase} from "../gqlModel/GqlModelBase";
import {Task} from "./gql/serverTypes";
import {TaskReportFileMeta} from "./TaskReportModel";
import type {TaskGqlProvider} from "./TaskGqlProvider";
import type {IDataClientService} from "../../platform/services/data/DataClientService";
import type {IAuthService} from "../../platform/services/auth/AuthService";


export type TaskModelType = Instance<typeof TaskModel>;


export interface TaskModelEnv {
    getDataClientService: () => IDataClientService;
    authService: IAuthService;
    queryProvider: TaskGqlProvider;
}

export const TaskModel = getGqlModelBase<Task>()
    .named("TaskModel")
    .props({
        id: types.optional(types.identifier, ''),
        taskListUnitId: types.string,
        taskListId: types.optional(types.maybeNull(types.string), null),
        name: types.string,
        description: types.optional(types.string, ''),
        scheduleRule: types.optional(types.frozen<any>(), {}),
        relatedPage: types.optional(types.maybeNull(types.string), null),
        config: types.frozen<any>(),
        images: types.optional(types.maybeNull(types.array(types.frozen<TaskReportFileMeta>())), []),
        isArchived: types.optional(types.boolean, false),
        version: types.optional(types.maybeNull(types.number), 0),
        createdAt: types.optional(types.string, ''),
        updatedAt: types.optional(types.string, ''),
        createdBy: types.optional(types.string, ''),
        updatedBy: types.optional(types.string, ''),
    })
    .views(self => ({
        get hasError() {
            return !self.name;
        },
        get isImageRequired() {
            return self.config?.isImageRequired;
        }
    }))
    .actions(self => ({
        proceedSaveResults(obj: Task) { // @ts-ignore
            self.lastSavedObject = obj!;
            self.version = obj.version;
        },
    }))
    .actions(self => ({
        setName(name: string) {
            self.name = name;
            self.hasChanges = true;
        },
        setDescription(desc: string) {
            self.description = desc;
            self.hasChanges = true;
        },
        setPage(pageId: string | null) {
            self.relatedPage = pageId;
            self.hasChanges = true;
        },
        setIsArchived(isArchived: boolean) {
            self.isArchived = isArchived;
            self.hasChanges = true;
        },
        setIsImageRequired(newValue: boolean) {
            self.config = {
                isImageRequired: newValue
            };
            self.hasChanges = true;
        },
        setScheduleRule(rule: any) {
            self.scheduleRule = rule;
            self.hasChanges = true;
        },
        setImages(imagePaths: TaskReportFileMeta[]) {
            if (self.images === null){
                self.images = cast(imagePaths);
            } else {
                self.images.replace(imagePaths);
            }
            self.hasChanges = true;
        },
    }));
